import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed } from "@components/atoms/Themed"
import { ResponsiveImageFragment } from "../../types.graphql"
import { twMerge } from "tailwind-merge"
import { EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { FormattedTitle } from "@components/atoms/FormattedTitle"
import { Link } from "eddev/routing"
import { Button } from "@components/ui/Button"
import { Icon, IconChevronRight } from "@components/ui/Icon"
import { Gradient } from "@components/motion/Gradient"

export const HeaderSecondary = ({
  title,
  theme,
  featuredImage,
  links,
}: {
  title?: string
  theme: string
  featuredImage?: ResponsiveImageFragment
  links?:
    | ({
        link: {
          target: string | null
          title: string | null
          url: string | null
        } | null
      } | null)[]
    | null
}) => {
  return (
    <Themed
      theme={theme}
      type="bg"
      className="w-full flex flex-col md:flex-row md:pl-7 pl-4 gap-7 pr-4 py-4 justify-between relative"
    >
      <Gradient
        theme={theme}
        className="absolute left-0 top-0 h-full bg-white"
        aspect="1/1"
        showImage={false}
        cutEdges={false}
        align="left"
        scale={1}
        // speed={0.5}
        bg={{ r: 1, g: 1, b: 1 }}
      />
      <div className="flex flex-col justify-between items-start w-full self-stretch relative">
        <div className="flex flex-col gap-6 mt-5 type-title-xxl">
          {env.admin ? (
            <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" plainText />
          ) : (
            title
          )}
        </div>
        <div className="w-pageHeaderSecondaryContentW flex flex-col gap-3 justify-start items-start mb-4 [&_p]:!type-body-m border-t-[0.1em] border-black pt-3">
          {links?.map(
            (link, i) =>
              link?.link && (
                <Link
                  key={i}
                  href={link.link.url}
                  target={link.link.target || undefined}
                  className="!w-full !flex justify-between items-center hover-link"
                >
                  <span>{link.link.title}</span>
                  <IconChevronRight className="w-4 h-4" />
                </Link>
              ),
          )}
        </div>
      </div>
      <div className="w-pageHeaderBrowseFeatW md:h-pageHeaderPrimaryH shrink-0 flex justify-center items-center relative">
        <ResponsiveImage {...featuredImage} objectFit="contain" className="w-full h-full" />
      </div>
    </Themed>
  )
}
